<template>
    <div class="root">
        <div class="hh-profile-container margin-top-50">
            <div class="panel panel-default" ref="top">
                <div class="container-fluid">

                    <div v-if="loading" class="section-body margin-top-50 margin-bottom-50">
                        <div class="row section margin-top-10">
                            <div class="col-sm-12 section-title">
                                <h1 class="text-center text-normal text-capitalize">
                                    Personal Information
                                </h1>
                            </div>
                        </div>
                        <LoadingAnimation/>
                    </div>

                    <form action="#"
                          @submit.prevent="submitForm"
                          class="form"
                    >
                        <div class="section-body margin-bottom-50" v-if="dataAnalysed">
                            <div v-show="!loading" class="row margin-top-20">
                                <div class="col-sm-12">
                                    <div class="personal-information-section" ref="personalInformation">
                                        <PersonalInformation
                                                ref="personalInformationComponent"
                                                :user-data="userData"
                                                :edit-mode="true"
                                                :identities="userData.identities"
                                                :errors="personalInformationErrors"
                                                @componentLoading="componentLoading"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row hh-form-btn-wrapper margin-bottom-20 margin-top-20" v-if="!loading">
                                      <div class="form-group col-sm-6">
                                        <button type="button" v-on:click="backAction"
                                                class="btn hh-btn back-btn" name="Cancel">
                                          Cancel
                                        </button>
                                      </div>
                                      <div class="form-group col-sm-6">
                                        <button type="submit" :disabled="!formReady"
                                                class="btn save-btn hh-btn-green" name="Save changes">
                                          Save Changes
                                        </button>
                                      </div>
                                    </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import PersonalInformation from '../../components/form/PersonalInformation'
  import Alert from '../../components/form/elements/Alert'
  import LoadingAnimation from '../../components/LoadingAnimation'
  import { scrollTo } from '../../utils/componentHelper'

  export default {
    name: 'PersonalInformationView',

    components: {
      PersonalInformation,
      Alert,
      LoadingAnimation,
    },

    props: {},

    beforeMount () {
      if (_.isEmpty(this.profileData)) {
        this.fetchData().then(() => {
          this.analyseUserData()
        })
      } else {
        this.analyseUserData()
      }
    },

    mounted () {
      scrollTo(this.$refs['top'])
    },

    data: () => {
      return {
        dataAnalysed: false,
        isFormReady: true,
        config: {},
        userData: {
          email: null,
          first_name: null,
          last_name: null,
          date_of_birth: null,
          phone: null,
          informationType: 'PersonalInformation',
          identities: null,
        },
        componentsLoadingStatus: {
          PersonalInformation: true,
        },
        staticData: null,
      }
    },

    methods: {
      ...mapActions('profile', ['fetchData', 'storeInformation']),

      componentLoading (componentName, value) {
        this.componentsLoadingStatus[componentName] = value
      },

      analyseUserData () {
        if (!_.isEmpty(this.profileData)) {
          this.fillUserData()
          this.fillConfigData()
          this.dataAnalysed = true
        }
      },

      fillUserData () {
        this.fillPersonalInformation()
        this.fillStaticData()
      },

      fillPersonalInformation () {
        this.userData = { ...this.userData, ...this.profileData.data.attributes }
      },

      fillStaticData () {
        if (!_.isEmpty(this.profileData.data.staticData)) {
          this.staticData = this.profileData.data.staticData
        }
      },

      fillConfigData () {
        if (!_.isEmpty(this.profileData.config)) {
          this.config = this.profileData.config
        }
      },

      backAction () {
        this.$router.back()
      },

      submitForm () {
        this.isFormReady = false
        this.componentsLoadingStatus.PersonalInformation = true

        if (this.processFormData()) {
          this.sendFormData()
        }

        return true
      },

      processFormData () {
        if (!this.$refs.personalInformationComponent.canSubmit()) {
          this.isFormReady = true
          this.componentsLoadingStatus.PersonalInformation = false
          scrollTo(this.$refs['top'])
          return false
        }

        return true
      },

      sendFormData () {
        this.storeInformation(this.$refs.personalInformationComponent.$data.formData).then(() => {
          if (this.personalInformationStatus === 'success') {
            this.$store.dispatch('fetchAuthUser').then(() => {
              this.$store.dispatch('profile/fetchData').then(() => {
                this.$store.commit('setAlert', {
                  message: 'Profile information updated.',
                  type: 'bg-success'
                })
                this.isFormReady = true
                this.componentsLoadingStatus.PersonalInformation = false
                this.$router.push({name: 'profile'})
              })
            })
          } else {
            this.isFormReady = true
            this.componentsLoadingStatus.PersonalInformation = false
          }
        })
      },

    },

    computed: {
      ...mapGetters('profile', ['profileData']),
      ...mapGetters(['alert']),

      loading () {
        for (let component in this.componentsLoadingStatus) {
          if (this.componentsLoadingStatus[component]) {
            return true
          }
        }

        return false
      },

      formReady () {
        return this.isFormReady === true
      },

      personalInformationStatus: {
        get () {
          return this.$store.getters['profile/storeInformationStatus'](this.userData.informationType)
        },
      },

      personalInformationErrors: {
        get () {
          return this.$store.getters['profile/storeInformationErrors'](this.userData.informationType)
        },
      },
    },
  }
</script>

<style lang="scss" scoped>
    .root::v-deep {
        @import '../../../style/pages/profile';
    }

    h1 {
      font-family: Circular Std;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 33px;
      color: #000000;
    }
</style>